import { render, staticRenderFns } from "./unBindTable.vue?vue&type=template&id=80acbf4e&scoped=true&"
import script from "./unBindTable.vue?vue&type=script&lang=js&"
export * from "./unBindTable.vue?vue&type=script&lang=js&"
import style0 from "./unBindTable.vue?vue&type=style&index=0&id=80acbf4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80acbf4e",
  null
  
)

export default component.exports